import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';
import { BaseComponentContext } from '@tcm-modules/tcm-core.module';
import { GoogleMapsLoaderService } from '../../../../../services/google-maps-loader.service';

@Component({
    selector: 'map-modal',
    templateUrl: './map-modal.component.html',
    styleUrls: ['./map-modal.component.scss'],
    standalone: false
})
export class MapModalComponent implements AfterViewInit  {
    @Input() public location: google.maps.LatLng;
    @ViewChild('gmap', { static: true }) gmapElement: any;

    public constructor(
        private componentContext: BaseComponentContext,
        private googleMapsLoader: GoogleMapsLoaderService
    ) {
    }

    public readonly goBack = (data?: any) => {
        this.componentContext.navService.navigateBack(data);
    };

    public async ngAfterViewInit() {        
        // Ensure Google Maps is loaded before using it
        await this.googleMapsLoader.load();
        
        const map = new google.maps.Map(this.gmapElement.nativeElement, {
            center: this.location,
            zoom: 15
        });

        new google.maps.Marker({
            position: this.location,
            map: map
        });
    }
}
